// eslint-disable-next-line func-names
FileReader.prototype.readAsBinaryString = function (fileData) {
  let binary = '';
  const pt = this;
  const reader = new FileReader();
  reader.onload = () => {
    const bytes = new Uint8Array(reader.result);
    const length = bytes.byteLength;
    for (let i = 0; i < length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }

    pt.content = binary;
    pt.onload();
  };
  reader.readAsArrayBuffer(fileData);
};

export default FileReader;
